import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatListItem } from '@blocks-react/components/ListItem';

type CatListItemProps = ComponentProps<typeof CatListItem> & {
  listClassName?: string;
};

export const VisionLinkCardItems: FC<PropsWithChildren<CatListItemProps>> = ({
  children,
  className,
  ...listItemProps
}) => (
    <CatListItem {...listItemProps} className={className}>
      {children}
    </CatListItem>
);
